import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  TextField,
  InputAdornment,
  Card,
  Typography,
} from "@mui/material";
import {
  useDeleteCustomerMutation,
  useGetCompanyQuery,
  useGetCustomerQuery,
  useGetWorkOrderQuery, 
  useGetAllInvoiceQuery,
  useGetCustomerProjectQuery,
  useDeleteCustomerProjectMutation,
} from "../../../Api/attoDeskApi";
import {
  ICompanyDetails,
  IQuoteWorkOrder,
  IInvoice,
  ICustomerProject,
  ICustomer
} from "../../../Api/Interface/api.interface";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { useNavigate, Link } from "react-router-dom";
import { fmtCustomerName } from '../../../Core/utils/nameUtils';
import { useStyles } from "../../../theme/appStyles";
import { useNotifier } from "../../../Core/Notifier";
import { CiSearch } from "react-icons/ci";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import CustomCheckbox from "../../../Components/Checkbox.tsx";
import Pagination from "../../../Components/Pagination";
import { WorkOrderStatus } from "../../../Core/Enum/enum";
import dayjs,  { Dayjs } from "dayjs";
import AddProject from "./../../CustomerTransaction/Components/AddProject";

const getStatusLabel = (statusCode: number): string => {
  switch (statusCode) {
    case WorkOrderStatus.Paid:
      return "Paid";
    case WorkOrderStatus.Cancel:
      return "Canceled";
    case WorkOrderStatus.Pending:
      return "Pending";
      case WorkOrderStatus.Initiated:
        return "Initiated";
    default:
      return "Unknown Status";
  }
};

const getStatusColor = (statusCode: number): string => {
  switch (statusCode) {
    case WorkOrderStatus.Paid:
      return "#4caf50";
    case WorkOrderStatus.Cancel:
      return "#f44336";
    case WorkOrderStatus.Pending:
      return "#ff9800";
       case WorkOrderStatus.Initiated:
  return "#2196f3"
    default:
      return "#9e9e9e";
  }
};

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [selectedCoursing, setSelectedCoursing] =
    useState<IQuoteWorkOrder | null>(null);
  const debouncedSearchQuery = useDebounce(currentSearchQuery, 300);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] =
    useState<IQuoteWorkOrder | null>(null);
  const [invoiceList, setInvoiceList] = useState<IInvoice[]>([]);
  const [projectData, setProjecData] = useState<ICustomerProject>();
  const [openAddProject, setOpenAddProject] = useState(false);
  const [deleteProject] = useDeleteCustomerProjectMutation();
  const [projectToDelete, setProjectToDelete] =
      useState<ICustomerProject | null>(null);
  const [openDeleteProject, setOpenDeleteProject] = useState(false);

   const { data, isLoading, isError } = useGetCustomerQuery({
     searchText: "",
     id:"",     
   });
 
  
const {
    data: customerProjectData,
    isLoading: customerProjectDataIsLoading,
    refetch: cutomerProjectRefetch,
  } = useGetCustomerProjectQuery({
    searchText: currentSearchQuery,
    // customerId: String(customerId),
    id: "",
  });


  const { data: companyData, isLoading: companyLoading } = useGetCompanyQuery({
    searchText: "",
    id: "",
  });

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  // useEffect(() => {
  //   if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
  //     setCurrentSearchQuery(debouncedSearchQuery);
  //     refetch();
  //   }

  // }, [debouncedSearchQuery]);
   const project: ICustomerProject[] = useMemo(() => {
     if (customerProjectData && Array.isArray(customerProjectData.data)) {
       return customerProjectData.data as ICustomerProject[];
     }
     return [];
   }, [customerProjectData]);

     const customer = useMemo(() => {
       if (data && Array.isArray(data.data) && data.data.length > 0) {
         return data.data as ICustomer[];
       }
       return null;
     }, [data]);


  // useEffect(() => {
  //   if (invoiceList.length === 0) {
  //     invoiceRefetch(); // Trigger the refetch immediately
  //   }
  // }, [invoiceList, invoiceRefetch]);

  // // Update invoiceList when invoiceData is fetched
  // useEffect(() => {
  //   if (invoiceData?.data) {
  //     const invoiceDataArray = Array.isArray(invoiceData?.data) ? invoiceData.data : [];
  //     setInvoiceList(invoiceDataArray);
  //   }
  // }, [invoiceData]);

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

   const handleOpenAddProject = () => {
        setProjecData(undefined);
        setOpenAddProject(true);
      };

      const handleCloseAddProject = () => {
        setProjecData(undefined);
        setOpenAddProject(false);
      };

          const handleOpenDeleteProjectPopup = (project: ICustomerProject) => {
              setProjectToDelete(project);
              setOpenDeleteProject(true);
            };
      
            const handleCloseDeleteProjectPopup = () => {
              setProjectToDelete(null);
              setOpenDeleteProject(false);
            };
      
            const handleDeleteProject = async (id: string) => {
              try {
                const response = await deleteProject(id).unwrap();
                if (response.status) {
                  showMessage("Deleted successfully");
                  setOpenDeleteProject(false);
                  // const refetchResult = await refetchActivityHistory();
                } else {
                  showErrorMessage("Failed to delete the customer project");
                }
              } catch (error) {
                showErrorMessage("Failed to delete the customer project");
              }
            };


  const handleOpenDialog = (coursing: IQuoteWorkOrder) => {
    setSelectedCoursing(coursing);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedCoursing(null);
    setOpenDialog(false);
  };

  const handleOpenDeletePopup = (coursing: IQuoteWorkOrder) => {
    setCoursingToDelete(coursing);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  const [deleteCategory] = useDeleteCustomerMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage("Deleted successfully");
        setOpenDeleteCategory(false);
      } else {
        showErrorMessage("Failed to delete the customer");
      }
    } catch (error) {
      showErrorMessage("Failed to delete the customer");
    }
  };

  if (isLoading)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );

 
  const handleSearch = () => {
    setCurrentSearchQuery(searchQuery);
  };

  const resetFields = () => {
    setSearchQuery("");
    setCurrentSearchQuery("");
    // refetch();
  };

  const handleAddProductClick = () => {
    navigate("/quote/create");
  };

  const handleInvoiceClick = (invoiceId: number) => {
    navigate(`/invoice/history/${invoiceId}`);
  };

  return (
    <Card className={classes.card}>
      <Grid
        container
        justifyContent={"space-between"}
        spacing={5}
        sx={{ borderBottom: 2, padding: 2 }}
        className={classes.titleGrid}
      >
        <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
          <Typography className={classes.cardTitle}>Projects</Typography>
        </Grid>
        <Grid
          item
          lg={8}
          md={8}
          sm={8}
          xs={8}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Grid
            container
            spacing={1}
            justifyContent="flex-end"
            sx={{ display: "flex" }}
          >
            <Grid item>
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CiSearch className={classes.searchWidgetIcon} />
                    </InputAdornment>
                  ),
                  classes: {
                    root: classes.formControlList,
                  },
                }}
                fullWidth
                value={currentSearchQuery}
                onChange={(e) => setCurrentSearchQuery(e.target.value)}
                 placeholder="Project Name .."
                sx={{ width: "100%" }}
                size="small"
              />
            </Grid>

          
          </Grid>
        </Grid>
      </Grid>

      <Grid>
        <TableContainer>
            <Table sx={{
          width: "100%",
          marginBottom: "1.5rem",
          verticalAlign: "top",
          "& > :not(caption) > * > *": {
            padding: "10px", // Ensure custom padding is applied
          },}}>
                                    <TableHead className={classes.tableHeaderRow}>
                                      <TableRow>
                                          <TableCell className={classes.tablheader}>
                                                          <strong>#</strong>
                                                        </TableCell>
                                        <TableCell className={classes.tablheader}>
                                          <strong>Project Name</strong>
                                        </TableCell>
                                         <TableCell className={classes.tablheader}>
                                                          <strong>Client</strong>
                                                        </TableCell>
                                        <TableCell className={classes.tablheader}>
                                          <strong>Create Date</strong>
                                        </TableCell>
      
                                        <TableCell
                                          className={classes.tablheader}
                                          sx={{ textAlign: "right" }}
                                        >
                                          <strong>Actions</strong>
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                         {isError || project.length === 0 ? (
                                                      <TableRow>
                                                        <TableCell colSpan={20} align="center">
                                                          {isError ? "Error fetching data" : "No data available"}
                                                        </TableCell>
                                                      </TableRow>
                                                    ) : (
                                      project.map((project, index) => {
                                 
const customers = customer?.find(c => c.id === Number(project.customerId));

                  
                                        return (

                                            <TableRow
                                          key={project.id}
                                          className={classes.tableRowHover}
                                        >
                                           <TableCell scope="row" className={classes.tablCell}>
                                                                    {page * rowsPerPage + index + 1}
                                                                  </TableCell>
                                          <TableCell
                                            component="th"
                                            scope="row"
                                            className={classes.tablCell}
                                          >
                                            {project.projectName}
                                          </TableCell>
                                         <TableCell  scope="row"
                                            className={classes.tablCell}>
  {fmtCustomerName(customers, '-')}
</TableCell>
                                          <TableCell
                                            scope="row"
                                            className={classes.tablCell}
                                          >
                                            {project?.created_at
                                              ? dayjs(project.created_at).format(
                                                  "MMM D, YYYY [at] h:mm A"
                                                )
                                              : ""}
                                          </TableCell>
                                          <TableCell className={classes.tablCell}>
                                            <Grid
                                              container
                                              spacing={1}
                                              sx={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                              }}
                                            >
                                              <Grid item>
                                                <Button
                                                  component={Link}
                                                  variant="contained"
                                                  className={classes.viewButtonList}
                                                    to={`/customer-history/project/${project.id}`}
                                                 
                                                >
                                                  <VisibilitySharpIcon
                                                    className={classes.viewListIcon}
                                                  />
                                                </Button>
                                              </Grid>
      
                                              
                                              <Grid item>
                                                <Button
                                                  variant="contained"
                                                  className={classes.editButtonList}
                                                  onClick={() => {
                                                    setProjecData(project);
                                                   setOpenAddProject(true);
                                                  }}
                                                >
                                                  <EditSharpIcon
                                                    className={classes.editListIcon}
                                                  />
                                                </Button>
                                              </Grid>
                                              <Grid item>
                                                <Button
                                                  variant="contained"
                                                  className={classes.deleteButtonList}
                                                  onClick={() =>
                                                    handleOpenDeleteProjectPopup(project)
                                                  }
                                                >
                                                  <DeleteOutlineSharpIcon
                                                    className={classes.deleteListIcon}
                                                  />
                                                </Button>
                                              </Grid>
                                            </Grid>
                                          </TableCell>
                                        </TableRow>

  )}
              ))}

                                               
                                    </TableBody>
                                  </Table>
          <Grid
            spacing={5}
            p={"18px"}
            py={4}
            justifyContent={"end"}
            container
            textAlign={"center"}
            alignContent={"center"}
            alignItems={"center"}
          >
            <Grid
              sx={{
                textAlign: "end",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <Pagination
                count={project.length}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={handleChangePage}
              />
            </Grid>
          </Grid>
        </TableContainer>

        {openAddProject && (
                            <AddProject
                              openModel={openAddProject}
                              handleCloseDialog={handleCloseAddProject}
                              data={projectData}
                             customerId={projectData?.customerId}
                            />
                          )}
                          {projectToDelete && (
                            <DeletePopup
                              open={openDeleteProject}
                              handleCloseDelete={handleCloseDeleteProjectPopup}
                              onConfirm={async () => {
                                await handleDeleteProject(
                                  projectToDelete.id.toString()
                                );
                              }}
                              title="Delete Project"
                              content={`Are you sure you want to delete "${projectToDelete.projectName}"?`}
                            />
                          )}
      </Grid>
    </Card>
  );
};

export default Index;
